import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { isEmpty as _isEmpty } from 'lodash'
import { useParams } from 'react-router-dom'

import EmptyState from 'components/Shared/EmptyState'
import Loading from 'components/Shared/Loading'

import {
  getOrganizations,
  updateOrganizationName,
  fetchOrganizations,
  getCurrentOrganization,
  setCurrentOrganization,
} from 'ducks/organizations'
import { useFunnelTracking } from 'hooks/useFunnelTracking'

import { getCurrentUserToken } from 'ducks/users/index.ts'

import UsageSection from './UsageSection'
import FreePlanFlow from './FreeFlowSection'
import PlanAndServices from './BillingSection/PlansAndServices'
import PaymentMethods from './BillingSection/PaymentMethods'

const BillingSub = props => {
  const { organization, onReload, appId } = props

  if (_isEmpty(organization)) {
    return null
  }

  if (!organization.active) {
    return (
      <div className="team-settings-sub-free">
        <FreePlanFlow />
        <UsageSection organization={organization} appId={appId} />
      </div>
    )
  }

  const showUsageSection = organization.planType !== 'trial'

  return (
    <div className="team-settings-sub">
      {showUsageSection && (
        <UsageSection organization={organization} appId={appId} />
      )}
      <h3 className="settings-header">Billing</h3>
      <div className="settings-content-box">
        <PlanAndServices organization={organization} />
        <hr />
        <PaymentMethods organization={organization} onSuccess={onReload} />
      </div>
    </div>
  )
}

const Billing = ({
  fetchOrganizations,
  flags,
  currentOrganization,
  organizations,
  setCurrentOrganization,
  match,
  currentUserToken,
}) => {
  // React-Router adds `match` only when this component is rendered by a <Route>.
  // If we arrive here from somewhere else, gracefully handle the absence so the UI still works.
  const { appId } = useParams()
  const { trackViewedBillingTab } = useFunnelTracking()

  const fetchData = () => {
    if (currentUserToken) {
      fetchOrganizations()
    }
  }

  useEffect(() => {
    if (currentUserToken) {
      fetchData()
    }
  }, [currentUserToken])

  // Track billing tab access
  useEffect(() => {
    if (currentOrganization?.id) {
      trackViewedBillingTab(currentOrganization.id).catch(error => {
        console.error('Failed to track billing tab view:', error)
      })
    }
  }, [currentOrganization?.id, trackViewedBillingTab])

  // Ensure we always have a selected organization once the list is available
  useEffect(() => {
    if (!currentOrganization && organizations.length) {
      const defaultOrgId = organizations[0].id
      if (defaultOrgId) {
        setCurrentOrganization(defaultOrgId)
      }
    }
  }, [currentOrganization, organizations, setCurrentOrganization])

  const org = currentOrganization

  return (
    <div className="team-settings">
      {org ? (
        [
          <BillingSub
            key={org.id}
            organization={org}
            updateOrganizationName={updateOrganizationName}
            onReload={fetchData}
            flags={flags}
            appId={appId}
          />,
        ]
      ) : (
        <EmptyState className="usage-section">
          <Loading />
        </EmptyState>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  organizations: getOrganizations(state),
  currentOrganization: getCurrentOrganization(state),
  currentUserToken: getCurrentUserToken(state),
})

export default connect(mapStateToProps, {
  updateOrganizationName,
  fetchOrganizations,
  setCurrentOrganization,
})(Billing)
